import React from "react";

export const fmtEur = (n) => `${Number(n || 0).toFixed(2).replace(".", ",")} €`;

export const DAY_LABELS = {
  monday: "Lundi", tuesday: "Mardi", wednesday: "Mercredi",
  thursday: "Jeudi", friday: "Vendredi", saturday: "Samedi", sunday: "Dimanche",
};

export const DAY_ORDER = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const slotMinutes = (s) => {
  try {
    const [sh, sm] = (s.startTime || "").split(":").map(Number);
    const [eh, em] = (s.endTime || "").split(":").map(Number);
    return Math.max(0, (eh * 60 + em) - (sh * 60 + sm));
  } catch { return 0; }
};

export const fmtMins = (m) => {
  if (!m) return "";
  const h = Math.floor(m / 60); const r = m % 60;
  if (h && r) return `${h}h${String(r).padStart(2, "0")}`;
  if (h) return `${h}h`;
  return `${r} min`;
};

export const Field = ({
  label, value, onChange, type = "text", small = false,
  autoComplete, inputMode, name, placeholder, required,
  pattern, maxLength, "data-testid": testId,
}) => (
  <div>
    <label className="block text-xs uppercase tracking-widest text-stone-500 mb-1.5">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      autoComplete={autoComplete}
      inputMode={inputMode}
      placeholder={placeholder}
      required={required}
      pattern={pattern}
      maxLength={maxLength}
      data-testid={testId}
      className={`w-full bg-cream rounded-xl border border-blush-light ${small ? "px-3 py-2 text-sm" : "px-4 py-3 text-base"} focus:outline-none focus:ring-2 focus:ring-blush`}
    />
  </div>
);

export const Row = ({ label, value, color = "text-stone-700" }) => (
  <div className="flex items-center justify-between text-sm">
    <span className="text-stone-500">{label}</span>
    <span className={color}>{value}</span>
  </div>
);
